<template>
  <!-- footer -->
  <footer class="footer">
    <div class="container inner">
      <ul class="nav-wrapper">
        <li class="main-list">
          <p class="title-pc" @click="goPage('/Global')">글로벌 역량</p>
          <p class="title-mt">글로벌 역량</p>
          <ul class="sub-list">
            <li @click="goPage('/Global#content01')">In-House Language</li>
            <li @click="goPage('/Global#content02')">1:1 Co-Active</li>
            <li @click="goPage('/Global#content03')">Language Lab</li>
            <li @click="goPage('/Global#content04')">비즈니스 스킬</li>
            <li @click="goPage('/Global#content05')">직무역량향상</li>
            <li @click="goPage('/Global#content06')">이공계 영어논문향상</li>
            <li @click="goPage('/Global#content07')">기적의 7일 코스</li>
            <li @click="goPage('/Global#content08')">항공/방산 회화</li>
            <li @click="goPage('/Global#content09')">의료보건 회화</li>
            <li @click="goPage('/Global#content10')">AI Tutor</li>
          </ul>
        </li>
        <li class="main-list">
          <p class="title-pc" @click="goPage('/Nurture')">주재원/현채인 육성</p>
          <p class="title-mt">주재원/현채인 육성</p>
          <ul class="sub-list">
            <li @click="goPage('/Nurture#content01')">주재원 통합 솔루션</li>
            <li @click="goPage('/Nurture#content02')">글로컬라이제이션</li>
            <li @click="goPage('/Nurture#content03')">GTMS 경영시뮬레이션</li>
            <li @click="goPage('/Nurture#content04')">리:로케이션 서비스</li>
            <li @click="goPage('/Nurture#content05')">지역전문가 과정</li>
            <li @click="goPage('/Nurture#content06')">귀임자 DB화/매뉴얼</li>
            <li @click="goPage('/Nurture#content07')">사내강사 양성 과정</li>
          </ul>
        </li>
        <li class="main-list">
          <p class="title-pc" @click="goPage('/CrossCulture')">이문화 역량</p>
          <p class="title-mt">이문화 역량</p>
          <ul class="sub-list">
            <li @click="goPage('/CrossCulture#content01')">이문화 역량교육</li>
            <li @click="goPage('/CrossCulture#content02')">이문화 맞춤 특강</li>
            <li @click="goPage('/CrossCulture#content03')">
              이문화 스마트러닝
            </li>
          </ul>
        </li>
        <li class="main-list">
          <p class="title-pc" @click="goPage('/Leadership')">
            리더십 및 조직개발
          </p>
          <p class="title-mt">리더십 및 조직개발</p>
          <ul class="sub-list">
            <li @click="goPage('/Leadership#content01')">
              Core Strengths 업무성향진단
            </li>
            <li @click="goPage('/Leadership#content02')">CCL L4S</li>
            <li @click="goPage('/Leadership#content03')">리더십 딜레마</li>
            <li @click="goPage('/Leadership#content04')">
              플립 리더십 코칭 프로그램
            </li>
            <li @click="goPage('/Leadership#content05')">코칭 플랫폼</li>
            <li @click="goPage('/Leadership#content06')">글로벌 팀빌딩</li>
          </ul>
        </li>
        <li class="main-list">
          <p class="title-pc" @click="goPage('/Digital')">디지털 역량</p>
          <p class="title-mt">디지털 역량</p>
          <ul class="sub-list">
            <li @click="goPage('/Digital#content01')">데이터씽킹</li>
            <li @click="goPage('/Digital#content02')">직원경험</li>
            <li @click="goPage('/Digital#content03')">고객경험</li>
          </ul>
        </li>
        <li class="main-list">
          <p class="title-pc" @click="goPage('/Customized')">맞춤 해외 연수</p>
          <p class="title-mt">맞춤 해외 연수</p>
          <ul class="sub-list">
            <li @click="goPage('/Customized#content01')">실리콘밸리 코스</li>
            <li @click="goPage('/Customized#content02')">싱가포르 금융 연수</li>
            <li @click="goPage('/Customized#content03')">기업 탐방</li>
            <li @click="goPage('/Customized#content04')">해외 Tech MBA</li>
            <li @click="goPage('/Customized#content05')">
              산업,정책시찰 해외연수
            </li>
            <li @click="goPage('/Customized#content06')">
              스타트업 리더 멘토링
            </li>
            <li @click="goPage('/Customized#content07')">맞춤형 온라인 교육</li>
            <li @click="goPage('/Customized#content08')">공동 프로젝트</li>
          </ul>
        </li>
        <li class="main-list">
          <p class="title-pc" @click="goPage('/Consulting')">진단 및 컨설팅</p>
          <p class="title-mt">진단 및 컨설팅</p>
          <ul class="sub-list">
            <li @click="openPage('http://www.thespac.net/new/')">SPAC^</li>
            <li @click="goPage('/Consulting#content01')">글로벌역량진단</li>
            <li @click="goPage('/Consulting#content02')">리더십역량진단</li>
            <li @click="goPage('/Consulting#content03')">마음건강진단</li>
            <li @click="goPage('/Consulting#content04')">성격유형검사</li>
            <li @click="goPage('/Consulting#content05')">맞춤컨텐츠 개발</li>
          </ul>
        </li>
        <li class="main-list">
          <p class="title-pc" @click="goPage('/Introduce')">회사소개</p>
          <p class="title-mt">회사소개</p>
          <ul class="sub-list">
            <li @click="goPage('/Philosophy')">경영철학</li>
            <li @click="goPage('/Culture')">기업문화</li>
            <li @click="goPage('/Ceo')">CEO 메세지</li>
            <li @click="goPage('/news-letter')">사보 당근농장</li>
            <li @click="goPage('/Articles')">Articles(연구발표)</li>
            <li @click="goPage('/History')">회사연혁</li>
            <li @click="goPage('/News')">보도자료</li>
            <li @click="goPage('/Recruit')">인재채용</li>
          </ul>
        </li>
        <li class="main-list">
          <p class="title-pc" @click="openPage('http://carrotglobal.net/')">
            ENGLISH
          </p>
          <p class="title-mt" @click="openPage('http://carrotglobal.net/')">
            ENGLISH
          </p>
        </li>
      </ul>
      <div class="bottom-wrapper">
        <div class="info-wrapper">
          <p>
            (주)캐럿글로벌 | 서울특별시 용산구 한남동 이태원로 268-20 |
            <span class="clickable" @click="goPage('/PrivacyPolicy')"
              >개인정보처리방침</span
            >
          </p>
          <p>
            대표이사 노상충 Copyright ⓒ<b>CARROT Global</b> Inc. All rights
            reserved.
          </p>
          <p>
            사업자 등록번호 211-88-50791 | 통신판매업 신고번호 제
            2017-서울강남-02979호 | 연락처 : 02-518-5467
          </p>
          <p>호스팅제공자 : 네이버 클라우드 | 개인정보관리책임자 : 김범진</p>
        </div>
        <div class="sns-family-wrapper">
          <div class="sns-wrapper">
            <p>FOLLOW US :</p>
            <ul>
              <li>
                <img
                  @click="openPage('https://www.instagram.com/carrotglobal')"
                  src="@/assets/img/newGlobal/main/footer/sns1.png"
                  alt="instagram"
                />
              </li>
              <li>
                <img
                  @click="openPage('https://www.facebook.com/thecarrotglobal/')"
                  src="@/assets/img/newGlobal/main/footer/sns2.png"
                  alt="facebook"
                />
              </li>
              <li>
                <img
                  @click="openPage('https://blog.naver.com/carrot_global')"
                  src="@/assets/img/newGlobal/main/footer/sns3.png"
                  alt="blog"
                />
              </li>
              <li>
                <img
                  @click="
                    openPage(
                      'https://www.youtube.com/channel/UCm_Fas_UHeXdiJvF4lADHjA'
                    )
                  "
                  src="@/assets/img/newGlobal/main/footer/sns4.png"
                  alt="youtube"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      site: "",
    };
  },
  methods: {
    openPage(path) {
      window.open(path, "_blank");
    },
    goPage(path) {
      location.href = path;
    },
  },
  mounted() {
    // footer nav
    const titleMt = document.querySelectorAll(".title-mt");
    titleMt.forEach(function (titleItems) {
      titleItems.addEventListener("click", function () {
        if (titleItems.nextSibling.classList.contains("active")) {
          titleItems.nextSibling.classList.remove("active");
        } else {
          const isActive = document.querySelectorAll(".active");
          isActive.forEach(function (activeItems) {
            activeItems.classList.remove("active");
          });

          titleItems.nextSibling.classList.add("active");
        }
      });
    });
  },
};
</script>

<style lang="scss" scoped>
a,
img {
  display: block;
}

article {
  display: block;
}

.container {
  width: calc(100% - 40px);
  max-width: 1200px;
  margin: 0 auto;
}

.clickable {
  cursor: pointer;
}

footer {
  background-color: #000000;

  a {
    color: #ffffff;
  }

  .title-pc {
    display: none;
  }

  .title-mt {
    font-size: 14px;
    color: #ffffff;
  }

  .inner {
    padding: 20px 0;

    .nav-wrapper {
      display: flex;
      flex-direction: column;

      .main-list {
        position: relative;
        border-bottom: 1px solid #252424;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 10px;

          &::after {
            content: none;
          }
        }

        &::after {
          content: "+";
          position: absolute;
          top: -3px;
          right: 4px;
          color: #ffffff;
        }

        .title-mt {
          margin-bottom: 10px;
          cursor: pointer;
        }

        .sub-list {
          display: none;
          background-color: #252424;

          li {
            font-size: 12px;
            color: #999999;
            padding: 15px 10px;
            cursor: pointer;
          }

          &.active {
            display: block;
          }
        }
      }
    }

    .bottom-wrapper {
      display: flex;
      flex-direction: column-reverse;
      gap: 20px 0;
      padding-top: 20px;

      .info-wrapper {
        display: flex;
        flex-direction: column;
        gap: 10px;
        font-size: 12px;
        color: #999999;

        a {
          display: inline-block;
          color: #999999;
        }
      }

      .sns-family-wrapper {
        font-size: 12px;
        color: #999999;

        .sns-wrapper {
          display: flex;
          align-items: center;
          gap: 0 5px;

          ul {
            display: flex;
            gap: 0 5px;

            li img {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  footer {
    .title-pc {
      display: block;
      font-size: 16px;
      color: #ffffff;
      margin-bottom: 10px;
      cursor: pointer;
    }

    .title-mt {
      display: none;
    }

    .inner {
      padding: 50px 0;

      .nav-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 0 20px;
        padding-bottom: 40px;
        border-bottom: 1px solid #333333;

        .main-list {
          border-bottom: 0 none;
          margin-bottom: 0;

          &:last-child {
            margin-bottom: 0;
          }

          &::after {
            content: none;
          }

          .sub-list {
            display: block;
            background-color: transparent;

            li {
              font-size: 13px;
              padding: 0;
              margin-bottom: 10px;
            }

            li:last-child {
              margin-bottom: 0;
            }
          }
        }
      }

      .bottom-wrapper {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 0;

        .sns-family-wrapper {
          display: flex;
          align-items: center;
          gap: 0 20px;
        }
      }
    }
  }
}
</style>
